import { Requisition } from "../../models/RestModels";

export function getEmptyRequisition(): Requisition
{
		return {
			id: 0,
			note: '',
			required_by_store_id : 0,
			requested_to_store_id: null,
			approved_status: 'PENDING',
		}
}
